import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CdpPriceDetailCard from "./component";
import { setSelectedEwPlan, updateExtendedWarrantySelection } from "../car-details/actions";

const mapStateToProps = ({
    carDetails: {
        isExtendedWarrantySelected = false,
        content
    }
}) => {
    return {
        isExtendedWarrantySelected,
        content
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateExtendedWarrantySelectionConnect: updateExtendedWarrantySelection,
    setSelectedEwPlanConnect: setSelectedEwPlan
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CdpPriceDetailCard);
